import { render, staticRenderFns } from "./FacePanel.vue?vue&type=template&id=2d8f564e&scoped=true"
import script from "./FacePanel.vue?vue&type=script&lang=js"
export * from "./FacePanel.vue?vue&type=script&lang=js"
import style0 from "./FacePanel.vue?vue&type=style&index=0&id=2d8f564e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8f564e",
  null
  
)

export default component.exports